import React from 'react';
import { UNPROCESSED_EMAILS } from "@/api/queries";
import UnprocessedEmailsTable from "@/features/unprocessed-emails/UnprocessedEmailsTable";
import { usePaginatedTableRequest } from '@/components/tables/hooks/usePaginatedTableRequest';

const UnprocessedEmails = () => {
  const {
    data,
    pagination,
    setPagination,
    loading
  } = usePaginatedTableRequest(UNPROCESSED_EMAILS);
  
  return (
    <UnprocessedEmailsTable 
      unprocessedEmails={data?.unprocessedEmails?.items}
      pagination={pagination}
      setPagination={setPagination}
      totalCount={data?.unprocessedEmails?.totalCount}
      loading={loading}
    />
  );
};

export default UnprocessedEmails;
